import { render } from "./TextTool.vue?vue&type=template&id=616aa70d&ts=true"
import script from "./TextTool.vue?vue&type=script&lang=ts"
export * from "./TextTool.vue?vue&type=script&lang=ts"

import "./TextTool.vue?vue&type=style&index=0&id=616aa70d&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__